import AppEventRegistry from "rev-cms-core/dist/common/AppEventRegistry";

const Events = new AppEventRegistry([
  "show-login-modal",
  "social-signin-result",
]);

export const EvtShowLoginModal = Events.get("show-login-modal");
